var colors = {
    maincolor:'#0A1929',
    bluecolor:'#5090D3',
    pinkish:'#d83563',
    white:'#ffffff2b',
    grocery:'#73CF31ab',
    doctor:'#9101006b',
    edu:'#6C119C6b',
    cream:'#ffffff',
    floodre:'#242424',
};


export default colors;